import React from "react";
import { Alert, Divider, Paper, Stack, Text, Title } from "@mantine/core";
import { useLocation, useNavigate, NavigateFunction, To, NavigateOptions } from "react-router-dom";

import {
  FlexTable,
  FuelTable,
  TripTable,
  FuelOverviewItem,
  FlexOverviewItem,
  TripOverviewItem
} from "./company-overview";

const fuelItems: FuelOverviewItem[] = [
  {
    id: "fuel-e2e-1",
    _collection: "capturedFuelTankTransfer",
    _typeLabel: "Fuel transfer",
    transactionDate: "2026-05-28T11:15:00.000Z",
    assetName: "Tank 1",
    fuelReceiverSign: "Jordan Operator",
    documentNumber: "T000-000-301",
  },
];

const flexItems: FlexOverviewItem[] = [
  {
    id: "flex-e2e-1",
    _templateName: "Daily Checklist",
    submissionDate: "2026-05-28T10:05:00.000Z",
    submitterName: "Casey Inspector",
    documentNumber: "F000-000-302",
  },
];

const tripItems: TripOverviewItem[] = [
  {
    id: "trip-e2e-1",
    description: "Mine to depot run",
    status: "IN_PROGRESS",
    pickupAddress: "North Shaft",
    fleetDisplayName: "Truck 18",
    fleetOperatorNameAndSurname: "Taylor Driver",
  },
];

export default function E2EClickableEntities() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const lastTarget = searchParams.get("target") || "none";

  const captureTarget = ((to: To | number, options?: NavigateOptions) => {
    if (typeof to === "string") {
      navigate(`/__e2e__/clickable-entities?target=${encodeURIComponent(to)}`);
    }
  }) as NavigateFunction;

  return (
    <Stack spacing="lg" p="lg" style={{ maxWidth: 1200, margin: "0 auto" }}>
      <div>
        <Title order={2}>Clickable Entities Harness</Title>
        <Text color="dimmed">
          Browser-level regression check for report-viewer entity click targets.
        </Text>
      </div>

      <Alert color="blue" title="Last captured target" data-testid="captured-target">
        {lastTarget}
      </Alert>

      <Paper withBorder p="md" radius="md">
        <Text weight={500} mb="sm">Fuel entities</Text>
        <FuelTable items={fuelItems} navigate={captureTarget} />
      </Paper>

      <Divider />

      <Paper withBorder p="md" radius="md">
        <Text weight={500} mb="sm">Flex entities</Text>
        <FlexTable items={flexItems} navigate={captureTarget} />
      </Paper>

      <Divider />

      <Paper withBorder p="md" radius="md">
        <Text weight={500} mb="sm">Trip entities</Text>
        <TripTable items={tripItems} navigate={captureTarget} />
      </Paper>
    </Stack>
  );
}